import * as XLSX from 'xlsx';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    headers: string[];
    onExport: Function;
    optionIcon?: string;
    customName?: string;
    canExport?: boolean;
}

export const ExportHeadersXLSX = ({
    headers,
    onExport,
    optionIcon,
    customName,
    canExport
}: Props) => {

    const exportToExcel = () => {

        const worksheet = XLSX.utils.aoa_to_sheet([
            headers
        ]);

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            'Hoja1'
        );

        const excelBuffer = XLSX.write(
            workbook,
            {
                bookType: 'xlsx',
                type: 'array'
            }
        );

        const dataBlob = new Blob(
            [excelBuffer],
            {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        );

        const fileName = _single.basicName(
            customName
                ? customName
                : 'plantilla'
        );

        onExport(fileName);

        const link = document.createElement('a');
        const url = URL.createObjectURL(dataBlob);

        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);

    };

    return (
        <>
            {(canExport || _single.canExport()) &&

                <button
                    title='Exportar XLSX'
                    type="button"
                    className="btn btn--primary btn-icon"
                    onClick={exportToExcel}
                >

                    <i
                        className={
                            optionIcon
                                ? `${optionIcon} m-2 icontable`
                                : 'ri-file-excel-2-line icontable'
                        }
                    ></i>

                </button>

            }
        </>
    );

};